import { CepId } from '@flysas-tech/book-value-stream-models';
import { Object, Optional, Record, Number, Static, String } from '@sinclair/typebox';

import { TierCode } from '../../../schemas/sas-domain';
import { StringEnumSchema } from '../../../utils/types';

export type GetAccrualPointsRequestQuery = Static<typeof GetAccrualPointsRequestQuery>;
export const GetAccrualPointsRequestQuery = Object({
  offerId: String(),
  flightId: String(),
  cepId: Optional(StringEnumSchema(CepId)),
  tierCode: Optional(StringEnumSchema(TierCode)),
});

export type AccrualPoints = Static<typeof AccrualPoints>;
const AccrualPoints = Object({
  bonusPoints: Number(),
  levelPoints: Number(),
});

export type AccrualPointsMap = Static<typeof AccrualPointsMap>;
export const AccrualPointsMap = Record(String(), AccrualPoints, { description: 'Map of productId: AccrualPoints' });
